module.exports = __webpack_public_path__ + "img/360_step_1.72151bec.png";